import "./../utils/interceptors";
import axios from "axios";
import cookie from "react-cookies";
import qs from "qs";
import { IDENTITY_CONFIG } from "../utils/authConst";

export const authService = (function () {
  const publicAPIs = {};
  let isAuthenticated = false;
  const Identity = IDENTITY_CONFIG;

  publicAPIs.getAccessToken = () => {
    return cookie.load("accessToken");
  };
  publicAPIs.getRefreshToken = () => {
    return cookie.load("refreshToken");
  };
  publicAPIs.setToken = (credentials) => {
    cookie.save("accessToken", credentials.access_token, {
      path: "/",
      maxAge: 1.296e6,
    });
    cookie.save("refreshToken", credentials.refresh_token, {
      path: "/",
      maxAge: 1.296e6,
    });
  };

  publicAPIs.isAuthenticated = async () => {
    if (isAuthenticated) {
      return true;
    }
    if (cookie.load("accessToken") && cookie.load("refreshToken")) {
      try {
        await publicAPIs.request({
          method: "GET",
          url: "/connect/userinfo",
        });
        isAuthenticated = true;
        return isAuthenticated;
      } catch (error) {
        return false;
      }
    } else {
      return false;
    }
    // return true
  };
  // My public methods will get added to this object
  // A public method
  publicAPIs.login = async (username, password) => {
    try {
      const loginReq = {
        method: "POST",
        url: "/connect/token",
        data: qs.stringify({
          grant_type: "password",
          username,
          password,
          client_id: "asdf",
        }),
        authorized: false,
      };
      const authenticatedUser = await publicAPIs.request(loginReq);
      const { access_token, refresh_token } = authenticatedUser;
      isAuthenticated = true;
      cookie.save("accessToken", access_token, { path: "/", maxAge: 1.296e6 });
      cookie.save("refreshToken", refresh_token, {
        path: "/",
        maxAge: 1.296e6,
      });
      const res = await axios({
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        method: "GET",
        baseURL: Identity.protocol + Identity.baseApiUrl,
        url: "/connect/userinfo",
      });
      localStorage.setItem("userLocale", res.address.Locale);
      localStorage.setItem("userFullName", res.given_name);
      localStorage.setItem("userPersonnelCode", res.address.PersonnelCode);
      localStorage.setItem("subDomain", res.website);
      localStorage.setItem("userImage", res.address.ImageName);
      return res;
    } catch (error) {
      throw error;
    }
  };
  publicAPIs.request = async ({
    method,
    url,
    params = {},
    data = {},
    headers = {},
    authorized = true,
    ...config
  }) => {
    if (authorized) {
      return axios({
        headers: {
          ...headers,
        },
        method: method,
        baseURL:
          Identity.protocol +
          localStorage.getItem("subDomain") +
          "." +
          Identity.baseUrl,
        url: url,
        params: {
          ...params,
        },
        data: data,
      });
    } else {
      return axios({
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          ...headers,
        },
        method: method,
        baseURL: Identity.protocol + Identity.baseApiUrl,
        url: url,
        data: data,
        validateStatus: function (status) {
          return status >= 200 && status < 300; // default
        },
      });
    }
  };
  publicAPIs.logout = async () => {
    try {
      cookie.remove("accessToken", { path: "/" });
      cookie.remove("refreshToken", { path: "/" });
      cookie.remove("subDomain", { path: "/" });
      localStorage.clear();
    } catch (error) {
      throw error;
    }
  };
  publicAPIs.userHasPermission = async (pagePermission) => {
    try {
      const req = {
        method: "GET",
        url: "/api/permissionApi/GetPermissions",
      };
      const permissions = await publicAPIs.request(req);
      let isAllowed = false;
      if (permissions) {
        permissions.forEach((permission) => {
          if (pagePermission === permission.Policy) {
            isAllowed = true;
          }
        });
      }

      return isAllowed;
    } catch (error) {
      throw error;
    }
  };

  // Return our public methods so that they can be accessed
  return publicAPIs;
})();
